import { forwardRef, type ReactNode } from 'react'
import { IconButton as MuiIconButton, type IconButtonProps as MuiIconButtonProps } from '@mui/material'
import { Badge } from '../Badge'
import type { BadgeProps } from '../Badge'

export type IconButtonProps = MuiIconButtonProps & {
  badgeColor?: BadgeProps['color']
  badgeContent?: ReactNode
  badgeMax?: number
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { badgeColor = 'error', badgeContent, badgeMax = 99, children, ...props },
  ref,
) {
  return (
    <MuiIconButton ref={ref} {...props}>
      {badgeContent != null ? (
        <Badge badgeContent={badgeContent} color={badgeColor} max={badgeMax}>
          {children}
        </Badge>
      ) : (
        children
      )}
    </MuiIconButton>
  )
})
